export const assetTypes = ['devices', 'users', 'data', 'network'] as const;

export type AssetType = (typeof assetTypes)[number];

const assetTypeChecker: Set<string> = new Set(assetTypes);

export const isAssetType = (value: string | undefined): value is AssetType =>
  value !== undefined && assetTypeChecker.has(value);
